import { render, staticRenderFns } from "./searchabroad.vue?vue&type=template&id=95950a8e&scoped=true"
import script from "./searchabroad.vue?vue&type=script&lang=js"
export * from "./searchabroad.vue?vue&type=script&lang=js"
import style0 from "./searchabroad.vue?vue&type=style&index=0&id=95950a8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95950a8e",
  null
  
)

export default component.exports